import React from "react";
import { Hero } from "../components/Hero";
import { TrustBar } from "../components/TrustBar";
import WhatAreCapitalProjects from "../components/WhatAreCapitalProjects";
import { Problem } from "../components/Problem";
import BrandFilm from "../components/BrandFilm";
import { CognitiveSpine } from "../components/CognitiveSpine";
import { Link } from "react-router-dom";
import { PRODUCTS } from "../data/products";

/**
 * Homepage story arc:
 *   1. Hero            — declare the thesis
 *   2. TrustBar        — credibility anchor
 *   3. Education       — what are capital projects? + industries served (merged)
 *   4. Problem         — quantified pain (4 cards + pull quote)
 *   5. BrandFilm       — cinematic pause
 *   6. Platforms grid  — eight platforms (lifecycle order)
 *   7. CognitiveSpine  — interactive substrate visualisation
 */
export default function Home() {
  return (
    <>
      <Hero />
      <TrustBar />
      <WhatAreCapitalProjects />
      <Problem />
      <BrandFilm />

      {/* Eight platforms grid — lifecycle order, full set of 8 */}
      <section className="platforms reveal" data-testid="home-platforms-teaser">
        <div className="container">
          <div className="platforms-head">
            <div className="section-label">
              <span className="dot" />Eight platforms. One operating system.
            </div>
            <h2 className="platforms-h2 display">
              Every phase of the capital-projects lifecycle.{" "}
              <span style={{ color: "var(--text-3)" }}>Cognitively integrated.</span>
            </h2>
            <p className="platforms-sub">
              Eight Sanskrit-named platforms, ordered by lifecycle phase &mdash; design, assess, select, document, engineer, control, procure, and reason. Composable as a stack or independently.
            </p>
            <div style={{ marginTop: 28 }}>
              <Link to="/platforms" className="btn btn-primary" data-testid="home-explore-platforms">
                Explore all eight platforms <span className="arrow">→</span>
              </Link>
            </div>
          </div>
          <div className="platforms-grid" style={{ gridTemplateColumns: "repeat(4, 1fr)" }}>
            {PRODUCTS.map((p, i) => (
              <Link
                key={p.slug}
                to={`/platforms/${p.slug}`}
                className="product-card reveal"
                style={{ "--d": `${i * 60}ms`, minHeight: "auto" }}
                data-testid={`home-platform-teaser-${p.slug}`}
              >
                <div className="product-indo" style={{ marginBottom: 4 }}>
                  {p.indo}
                  <span className="product-dev">{p.devnagari}</span>
                </div>
                {p.english && (
                  <div className="product-english">{p.english}</div>
                )}
                <div className="product-name">{p.name}</div>
                <div className="product-tag" style={{ minHeight: "auto" }}>{p.tagline}</div>
                <div className="product-foot" style={{ marginTop: 20 }}>
                  <span className="product-explore">Explore <span className="arrow">→</span></span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <CognitiveSpine />
    </>
  );
}
